import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PublicLinkService } from '@simOn/public-link';
import { isDashboardTabAllowed, publicLinkFallbackTab } from '@simOn/public-link/models';

/**
 * Dashboard tabs a public link visitor may not open (disabled in DASHBOARD_PAGE_DATA_WITH_PRIVILEGES) redirect
 * to the fallback tab when reached by URL. Legacy links: Tasks and Events → Devices. JWT links: by capability → Devices or Assets.
 */
export const publicLinkDashboardTabGuardFn: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const publicLink = inject(PublicLinkService);
  const router = inject(Router);
  const access = publicLink.access();
  if (isDashboardTabAllowed(route.routeConfig?.path ?? '', access)) {
    return true;
  }
  const apartmentId = route.parent?.params['id'] ?? route.parent?.params['apartmentId'];
  return router.createUrlTree(['space', apartmentId, 'dashboard', publicLinkFallbackTab(access)]);
};
